import { styled } from '@mui/material/styles';
import { palette } from 'theme/palette';
import BlankIcon from 'assets/images/blank.svg';
import { TextOption } from './TextOption';
import { pxToRem } from 'src/common/utils/fonts';

const BlankRoot = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const IconBox = styled('div')(({ theme }) => ({
  width: theme.spacing(24),
  height: theme.spacing(24),

  '& > .blank-icon': {
    color: palette.grey[500],
  },
}));

type BlankOptionProps = {
  name: string;
  selected: boolean;
};

export const BlankOption = ({ name, selected }: BlankOptionProps) => {
  return (
    <BlankRoot>
      <TextOption name={name} selected={selected} labelTextColor="grey.500" />
      <IconBox>
        <BlankIcon width={pxToRem(24)} height={pxToRem(24)} className="blank-icon" />
      </IconBox>
    </BlankRoot>
  );
};
